export default __webpack_public_path__ + "static/media/discord_icon.9f1e54d7.png";